import { Pagination as PaginationComponent } from 'antd';
import { FC } from 'react';

import styles from './index.module.scss';

interface PaginationProps {
	total: number;
	onChange: (page: number) => void;
	current: number;
	pageSize?: number;
	showLessItems?: boolean
}
export const Pagination: FC<PaginationProps> = ({
	total, onChange, current, showLessItems = true, pageSize = 20
}) => {
	return (
		<div className={styles.root}>
			<PaginationComponent
				current={current}
				onChange={onChange}
				total={total}
				pageSize={pageSize}
				showSizeChanger={false}
				hideOnSinglePage
				showLessItems={showLessItems}
			/>
		</div>
	);
};
